<template>
  <div class="detailbox">
    <div class="productmain">
     <div>
      <div class="leftboxs">
       <div class="thumbnail">
        <div v-for="(item,index) in productinfo.imageList" :key="index" class="bnailitem" :class="{'select': selectIndex === index}">
          <img :src="item" alt="" v-on:mouseenter="changcurrent(item,index)"/>
        </div>
      </div>
       <div class="imgbox">
          <img :src="currentimg" alt="" />
        </div>
       
     </div>
      <div class="nextname">
          <div
            v-if="productinfo.lastProductName"
            @click="gonextdetail(productinfo.lastProductId)"
          >
            {{$t("message.prev")}}：{{ productinfo.lastProductName }}
          </div>
          <div
            v-if="productinfo.nextProductName"
            @click="gonextdetail(productinfo.nextProductId)"
          >
            {{$t("message.next")}}：{{ productinfo.nextProductName }}
          </div>
        </div>
     </div>
      <div class="brief">
        <h2 style="margin-bottom: 10px">{{ productinfo.productName }}</h2>
        <p class="informa">{{$t("message.codes")}}：{{ productinfo.code }}</p>
        <!-- <p>规格：{{productinfo.code}}</p> -->
        <p class="informa">{{$t("message.material")}}：{{ productinfo.material }}</p>
        <p class="informa">{{$t("message.color")}}：{{ productinfo.colour }}</p>
        <p class="informa">{{$t("message.brand")}}：{{ productinfo.brand }}</p>
        <p class="informa">{{$t("message.function")}}：{{ productinfo.function }}</p>
        <div class="btnbox" @click="linkus">
          <span>{{$t("message.consult")}}</span>
        </div>
      </div>
    </div>
    <div class="detailInfo">
      <div class="pdInfoSwitchTable">
        <div class="tabTitleWrap">
          <div class="borderselect">
            <span>产品详情</span>
          </div>
        </div>
      </div>
    </div>
    <div class="flex download">
        <div class="materials" style="border-right:1px solid rgb(102, 102, 102)">产品资料</div>
        <div class="materials" style="  cursor: pointer;" @click="godownload(productinfo.id)">点击下载</div>
      </div>
      <div v-for="(item,index) in productinfo.flatPatternList" :key="index" class="infoimg">
          <img :src="item" alt="" />
      </div>
  </div>
    <el-backtop :right="100" :bottom="100" />
  <linkService ref="linkservice"></linkService>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { useStore } from "vuex";
import { productInfoApi } from "@/api/index.js";
import linkService from "@/components/linkService.vue";
import { useRoute } from "vue-router";
import { useI18n } from "vue-i18n";
const { locale } = useI18n();
const route = useRoute();
let association = ref({});
onMounted(() => {
  const id = route.query.id;
  association.value = JSON.parse(route.query.formData);
  getList(association, id);
});
// 切换图片
let currentimg = ref('')
let selectIndex = ref(0)
const changcurrent = ((imgurl,index)=>{
currentimg.value = imgurl
selectIndex.value = index

})
// 点击下载
const godownload = ((val)=>{
  let data = JSON.stringify(association.value);
   window.open(
    `https://www.laolesiyun.com/materials?id=${val}&formData=${data}`,
    "_blank"
  );
    
})
let productinfo = ref({});
// 获取详情
const getList = (formData, id) => {
  productInfoApi({
    classId: formData.value.classId,
    keywords: formData.value.keywords,
    id,
    pid:formData.value.pid,
  })
    .then((res) => {
      productinfo.value = res;
      currentimg.value = res.imageList[0]      
    })
    .catch((err) => {
      console.log(err);
    });
};
// 上一个
const gonextdetail = (val) => {
  let data = JSON.stringify(association.value);
  window.open(
    `https://www.laolesiyun.com/productdetail?id=${val}&formData=${data}`,
    "_blank"
  );
};
// 联系客服
let linkservice = ref(null);
const linkus = () => {
  linkservice.value.dialogVisible = true;
};
</script>
<style scoped lang='scss'>
.detailbox {
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: 30px 0;
}
.productmain {
  margin-top: 30px;
  width: 70%;
  display: flex;
  align-items: flex-start;
  justify-content: center;
}
.imgbox {
  width: 500px;
  height: 500px;
  border: 1px solid #ebebeb;
  margin-bottom: 30px;
}
.brief {
  margin-left: 85px;
  text-align: left;
}
.informa {
  line-height: 40px;
}
.btnbox {
  border: 1px solid #00a0e9;
  color: #00a0e9;
  font-size: 16px;
  border-radius: 3px;
  cursor: pointer;
  text-align: center;
  width: 160px;
  line-height: 40px;
  margin-top: 45px;
}
.nextname {
  text-align: left;
  line-height: 50px;
  margin-left: 78px;
}
.pdInfoSwitchTable {
  line-height: 39px;
  margin: 0;
  padding: 0;
  position: relative;
  width: 100%;
}
.borderselect {
  color: #00a0e9;
  border-width: 5px 0 0;
  font-weight: 400;
  padding: 0 6px;
  border-top: 5px solid #00a0e9;
  text-align: center;
}
.detailInfo {
  text-align: left;
  width: 70%;
  border: 1px solid #eaeaea;
  margin-bottom: 50px;
}
.tabTitleWrap {
  border-right: 1px solid #efefef;
  width: 160px;
  line-height: 50px;
}
.download{
    background-color: #1f8fe8;
    border: 1px solid rgb(102, 102, 102);
    color: #fff;
    font-size: 24px;
    margin-bottom: 60px;
}
.infoimg{
    width: 750px;
    height: auto;
}
.materials{
    padding: 5px 10px;
}
.thumbnail{
  width: 90px;
  height: 500px;
}
.bnailitem{
  width: 66px;
  height: 66px;
  border: 1px solid #efefef;
  margin-bottom: 20px;
}
.leftboxs{
  display: flex;
}
.select{
  border: 3px solid #00a0e9;
}
</style>